<template>
  <div>
    <div class="relative z-50" aria-labelledby="modal-title" role="dialog" aria-modal="true">

      <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

      <div class="fixed inset-0 z-50 overflow-y-auto">
        <div class="flex h-full w-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div
            class="relative transform overflow-hidden rounded-lg bg-white  text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl">
            <div>
              <div class="bg-gray-50 ">
                <div class="container mx-auto">
                  <h4 class="font-bold text-center text-gray-800 text-xl p-1">Edit Evidence</h4>
                  <div
                    class="grid grid-cols-1 md:grid-cols-1 bg-white bg-opacity-80 border divide-y md:divide-y-0 md:divide-x">
                    <div>
                      <div class="bg-white cursor-move p-1 relative ">

                        <vue-cropper ref="cropper" crossorigin = "anonymous" :guides="true" :view-mode="2"
                          drag-mode="move" :background="true" style="max-height:70vh;" :check-cross-origin="false" :rotatable="true" :src="imgSrc"
                          alt="Source Image" :aspectRatio="8 / 7"></vue-cropper>
                      </div>
                    </div>
                    <div class="px-4 py-3">

                      <div class="text-right">

                        <button @click="rotate" v-if="imgSrc != ''"
                          class="inline-flex items-center bg-indigo-50 border border-indigo-700 cursor-pointer hover:bg-gray-50 py-0.5 px-4 rounded-full text-indigo-700 text-sm font-medium focus:outline-none ml-3">
                          <svg class="h-4 w-4 mr-1" viewBox="0 0 24 24" fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M21.8758 12.2H18.9758C18.8758 11.6333 18.7214 11.079 18.5128 10.537C18.3048 9.99567 18.0258 9.48333 17.6758 9L19.7508 7.05C20.3508 7.8 20.8384 8.61233 21.2138 9.487C21.5884 10.3623 21.8091 11.2667 21.8758 12.2ZM13.0508 23.025V20.15C13.6508 20.0667 14.2218 19.9207 14.7638 19.712C15.3051 19.504 15.8091 19.225 16.2758 18.875L18.2758 20.9C17.5258 21.5 16.7091 21.979 15.8258 22.337C14.9424 22.6957 14.0174 22.925 13.0508 23.025ZM19.7508 19.425L17.7008 17.425C18.0341 16.9583 18.3091 16.4543 18.5258 15.913C18.7424 15.371 18.8924 14.8167 18.9758 14.25H21.8758C21.8091 15.1667 21.5924 16.0583 21.2258 16.925C20.8591 17.7917 20.3674 18.625 19.7508 19.425ZM11.0508 23.025C8.50078 22.6917 6.38411 21.5957 4.70078 19.737C3.01745 17.879 2.17578 15.7 2.17578 13.2C2.17578 10.4667 3.10078 8.14567 4.95078 6.237C6.80078 4.329 9.05911 3.35833 11.7258 3.325L10.5508 2.15L12.5258 0.125L17.1508 4.75L12.5258 9.375L10.5508 7.35L11.7508 6.15C9.85078 6.2 8.25078 6.90833 6.95078 8.275C5.65078 9.64167 5.00078 11.2833 5.00078 13.2C5.00078 14.95 5.57178 16.4833 6.71378 17.8C7.85511 19.1167 9.30078 19.9 11.0508 20.15V23.025Z" />
                          </svg>
                          Rotate
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="flex gap-1.5 justify-center m-2 ">
                    <button @click="back" type="button"
                      class="rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 w-1/4">Cancel</button>
                    <button @click="cropImage" type="button"
                      class="rounded bg-indigo-500 w-1/4 p-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500 ">Save</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- cropper -->
  </div>
</template>
<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import { helpers } from "../../../../../mixins/helpers.js";
export default {
  props: ["uploadImgData", "isImageEdited"],

  mixins: [helpers],

  components: {
    VueCropper,
  },

  data() {
    return {
      imgSrc: "",
      showImageCropper: false,
      cropImg: "",
      blobSrc: "",
    };
  },

  created() {
    this.imgSrc = this.uploadImgData.img_src;
    if (this.isImageEdited) {
      this.fetchBlobSrc();
    }
  },

  computed: {
    finalImageSrc() {
      return this.isImageEdited && this.blobSrc !== ""
        ? this.blobSrc
        : this.imgSrc;
    }
  },

  methods: {
    async fetchBlobSrc() {
      const response = await fetch(this.uploadImgData.img_src, { mode: "cors" });
      const blob = await response.blob();
      this.blobSrc = URL.createObjectURL(blob);
    },

    cropImage(event) {
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL("image/jpeg");
      this.saveImage();
    },

    rotate() {
      this.$refs.cropper.rotate(90);
    },

    saveImage() {
      // if (this.cropImg == '') {
      // this.$emit("crop-image-data", { 'crop_img': this.uploadImgData.img_src, 'file_name': this.uploadImgData.file_name, 'uid': this.uploadImgData.uid });
      // } else {
      this.$emit("crop-image-data", { 'crop_img': this.cropImg, 'file_name': this.uploadImgData.file_name, 'uid': this.uploadImgData.uid });
      // }
      this.imgSrc = '';
    },

    back() {
      this.$emit("crop-image-data", { 'crop_img': this.uploadImgData.img_src, 'file_name': this.uploadImgData.file_name, 'uid': this.uploadImgData.uid });
      this.imgSrc = '';
    },

  },
  watch: {
  },
};
</script>